/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/PostActionDialog/theme';

export const PostActionDialogTheme = theme;
